"use client"

import { MapPin } from "lucide-react"

export const LocationMap = () => {
  return (
    <section className="py-16 sm:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-12 animate-in fade-in duration-700">
          <div className="inline-flex items-center gap-2 bg-amber-100 text-amber-800 px-4 py-2 rounded-full text-sm mb-4 font-semibold shadow-sm">
            <span className="w-2 h-2 bg-amber-600 rounded-full animate-pulse"></span>
            Come See Us in Person
          </div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Visit Our <span className="text-orange-600 font-bold">Office</span>
          </h2>
          <p className="text-base sm:text-lg text-gray-600 max-w-2xl mx-auto">
            Experience personalized travel planning at our Ortigas location
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-start">
          <div className="space-y-6 animate-in slide-in-from-left duration-700" style={{ animationDelay: '200ms' }}>
            <div className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-500 p-6 sm:p-8 border border-gray-100">
              <div className="flex items-start space-x-4">
                <div className="flex-shrink-0">
                  <div className="flex items-center justify-center w-12 h-12 rounded-full shadow-md bg-amber-600">
                    <MapPin className="w-6 h-6 text-white" />
                  </div>
                </div>
                <div>
                  <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-3 uppercase tracking-wide border-b-2 border-amber-500 pb-2 inline-block">
                    Main Office
                  </h3>
                  <p className="text-gray-700 leading-relaxed mt-4 text-sm sm:text-base">
                    Unit 1007 OMM Citra Bldg.
                    <br />
                    San Miguel Ave. Ortigas Center, Pasig City Philippines 1600
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br from-amber-50 to-orange-50 rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-500 p-6 sm:p-8 border border-amber-200">
              <h4 className="font-bold text-gray-900 mb-4 uppercase tracking-wide text-base sm:text-lg flex items-center gap-2">
                <span className="w-1 h-6 bg-amber-500 rounded-full"></span>
                How to Get Here
              </h4>
              <ul className="space-y-3 text-gray-700 text-sm sm:text-base leading-relaxed">
                <li className="flex items-start gap-3 hover:translate-x-1 transition-transform duration-300">
                  <span className="text-orange-500 font-bold text-lg">•</span>
                  <span>10-minute walk from Ortigas MRT Station</span>
                </li>
                <li className="flex items-start gap-3 hover:translate-x-1 transition-transform duration-300">
                  <span className="text-orange-500 font-bold text-lg">•</span>
                  <span>Accessible via EDSA and C-5 routes</span>
                </li>
                <li className="flex items-start gap-3 hover:translate-x-1 transition-transform duration-300">
                  <span className="text-orange-500 font-bold text-lg">•</span>
                  <span>Located along San Miguel Avenue</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="h-96 lg:h-full bg-gray-200 rounded-xl overflow-hidden shadow-xl border-4 border-white animate-in slide-in-from-right duration-700" style={{ animationDelay: '400ms', minHeight: '400px' }}>
            <iframe
              src="https://www.google.com/maps/embed/v1/place?key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8&q=Unit+1007+OMM+Citra+Building+San+Miguel+Ave+Ortigas+Center+Pasig+City+Philippines+1600&zoom=17"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Office Location Map"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  )
}
